import React, { useContext, useEffect, useState } from "react";
import {
  createPaymentOrderApi,
  paymentFailedStatusApi,
  paymentVerificationStatusApi,
} from "../../../Apis/PaymentApi";
import { UserAuthContext } from "../../../App";
import { toggleOrderStatusApi } from "../../../Apis/OrderApi";

const RazorpayPayment = ({ order, totalAmount }) => {
  const { userUid } = useContext(UserAuthContext);
  const [paymentSuccess, setPaymentSuccess] = useState(false);

  const handleMakePayment = async () => {
    try {
      const { orderID } = order;
      const providerID = 1;
      const response = await createPaymentOrderApi(
        orderID,
        totalAmount,
        providerID
      );
      initiateRazorpayPayment(response);
    } catch (error) {
      console.error("Failed to create order:", error);
    }
  };

  const initiateRazorpayPayment = (order) => {
    const paymentAmount = order.paymentAmount;
    const providerID = order.providerID;
    const orderID = order.orderID;
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY, // .env added this key
      amount: totalAmount,
      name: "NaayaTrade",
      order_id: order.id,
      handler: async function (response) {
        response.paymentAmount = paymentAmount;
        response.orderID = orderID;
        response.providerID = providerID;

        try {
          const paymentSuccess = await paymentVerificationStatusApi(
            response.razorpay_order_id,
            response.razorpay_payment_id,
            response.razorpay_signature,
            response.orderID,
            response.paymentAmount,
            response.providerID
          );

          if (paymentSuccess) {
            setPaymentSuccess(true);
            await buyerToggleOrderStatus(orderID, "In Process");
          } else {
            setPaymentSuccess(false);
            console.error("Payment verification failed.");
          }
        } catch (error) {
          console.error("Payment verification failed:", error);
        }
      },
      prefill: {
        name: userUid?.currentUser?.displayName || userUid?.currentUser?.email || '',
        email: userUid?.currentUser?.email || '',
        contact: userUid?.currentUser?.phoneNumber || '',
      },
      theme: {
        color: '#3399cc',
      }
    };
    const rzp1 = new window.Razorpay(options);
    rzp1.on("payment.failed", function (response) {
      const orderID = response.error.metadata.order_id;
      const paymentID = response.error.metadata.payment_id;
      handlePaymentFailure(orderID, paymentID);
    });
    rzp1.open();
  };

  const handlePaymentFailure = async (orderID, paymentID) => {
    try {
      await paymentFailedStatusApi(orderID, paymentID);
    } catch (error) {
      console.error("Payment failure status update failed:", error);
    }
  };

  // Buyer toggle status
  const buyerToggleOrderStatus = async (orderID, orderStatus) => {
    try {
      await toggleOrderStatusApi(orderID, orderStatus);
    } catch (error) {
      console.error("Error toggling order status:", error);
    }
  };

  useEffect(() => {
    if (paymentSuccess) {
      buyerToggleOrderStatus(order.orderID, "In Process");
    }
  }, [paymentSuccess]);

  return (
    <button
      className="w-[109px] h-[33px] bg-white border rounded-[5px] flex items-center justify-center font-medium text-[12px] text-black"
      onClick={handleMakePayment}
    >
      Make Payment
    </button>
  );
};

export default RazorpayPayment;
